import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { PatientMedicine } from '@dreryk/egabinet-prescription-frontend-api';
import { VisitDiagnosis } from '@dreryk/egabinet-visit-frontend-api';

import { LazyLoadedDataConfigurationByCqrsQuery } from '@dreryk/drerykweb-main-frontend';
import { Anchor, AnchorAlignment, EmptyStatePlaceholder, Table, TableKeyExtractor } from '@dreryk/react-components';

import { medicineSelectorTranslationKeys } from '../../../../../translations';
import { OnMedicineSelection } from '../../../PrescriptionIssuingPanel.types';
import { MedicineSearchText, MedicineSelectorIcd10Code } from '../../medicineSelector.types';
import { useMedicineSelectorTableColumns } from '../MedicineSelectorTable.hooks';
import { MedicineSelectorTableDataAccessor } from '../MedicineSelectorTableDataAccessor';

import { useSearchResultsMedicineSelectorConfiguration } from './SearchResultsMedicineSelectorTable.hooks';

export type SearchResultsMedicineSelectorTableProps = {
   readonly patientId: Patient['id'];
   readonly selectedIcd10Codes: MedicineSelectorIcd10Code[];
   readonly onMedicineSelection: OnMedicineSelection;
   readonly medicineSearchText: MedicineSearchText;
   readonly visitDiagnoses: VisitDiagnosis[];
};

export const keyExtractor: TableKeyExtractor<PatientMedicine> = (bean) => {
   return bean.medicine.id;
};

const SearchResultsMedicineSelectorTable = (props: SearchResultsMedicineSelectorTableProps): JSX.Element => {
   const dataConfiguration = useSearchResultsMedicineSelectorConfiguration(
      props.patientId,
      props.selectedIcd10Codes,
      props.medicineSearchText
   );
   const columns = useMedicineSelectorTableColumns(
      props.onMedicineSelection,
      props.patientId,
      dataConfiguration.refetch,
      props.visitDiagnoses,
      false
   );

   // TODO DREGAB-22246 To be replaced by sorting logic in backend after 05.02.2025
   const dataConfigurationTemp = {
      ...dataConfiguration,
      dataPart: dataConfiguration.dataPart
         ? {
              ...dataConfiguration.dataPart,
              data: dataConfiguration.dataPart?.data.sort((a, b) => {
                 return Number(Boolean(b.favorite)) - Number(Boolean(a.favorite));
              }),
           }
         : undefined,
   } as LazyLoadedDataConfigurationByCqrsQuery<PatientMedicine>;

   return (
      <>
         <Anchor shouldPerformScroll verticalAlignment={AnchorAlignment.START} testId={'medicineSearchResult'} />
         <Table<PatientMedicine>
            columns={columns}
            dataConfiguration={dataConfigurationTemp}
            keyExtractor={keyExtractor}
            dataAccessor={MedicineSelectorTableDataAccessor}
            placeholder={
               <EmptyStatePlaceholder
                  heading={medicineSelectorTranslationKeys.table.noMedicines}
                  subheading={medicineSelectorTranslationKeys.table.noResults}
                  testId={'medicineSearchNoResults'}
               />
            }
            testId={'medicineSearchResult'}
         />
      </>
   );
};

export { SearchResultsMedicineSelectorTable };
